import React from 'react';

const CalendarHeader = ({ children, className = '' }) => {
  return (
    <div className={`calendar-header ${className}`}>
      {children}
    </div>
  );
};

const CalendarHeaderLeft = ({ children, className = '' }) => {
  return (
    <div className={`calendar-header__left ${className}`}>
      {children}
    </div>
  );
};

const CalendarHeaderCenter = ({ children, className = '' }) => {
  return (
    <div className={`calendar-header__center ${className}`}>
      {children}
    </div>
  );
};

const CalendarHeaderRight = ({ children, className = '' }) => {
  return (
    <div className={`calendar-header__right ${className}`}>
      {children}
    </div>
  );
};

CalendarHeader.Left = CalendarHeaderLeft;
CalendarHeader.Center = CalendarHeaderCenter;
CalendarHeader.Right = CalendarHeaderRight;

export default CalendarHeader;
